import { useMemo } from 'react';

type UseGetPrices = {
  price: number;
  sharesToTransfer: number;
  isPricePerShare: boolean;
};

export const useGetPrices = ({
  price,
  sharesToTransfer,
  isPricePerShare,
}: UseGetPrices) => {
  const pricePerShare = useMemo(() => {
    if (isPricePerShare) return price;
    if (!sharesToTransfer) return 0;

    return price / sharesToTransfer;
  }, [price, sharesToTransfer, isPricePerShare]);

  const totalOfferPrice = useMemo(() => {
    if (isPricePerShare) return sharesToTransfer * price;

    return price;
  }, [price, sharesToTransfer, isPricePerShare]);

  return {
    data: { pricePerShare, totalOfferPrice },
  };
};
